// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M4 0H20V3H4V0Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M4 5H20V7.4141L17 10.4141V23.9999H7V10.4141L4 7.4141V5ZM13.0039 10H11V12.0039H13.0039V10Z"}}]};

const FlashlightFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'flashlight-filled',
    ref,
    icon: element,
  },
));

FlashlightFilledIcon.displayName = 'FlashlightFilledIcon';

export default FlashlightFilledIcon;
